import React from 'react';
import { Link } from 'react-router-dom';
import SingleBlogTwo from '../../components/Blog/SingleBlogTwo';
import { useCollections } from '../../lib/api/collections';

import titleImg from '../../assets/img/category/title.svg';
import { newsImages } from '../../data/images';

const Blog = () => {
  const { news } = useCollections('news');
  if (!news) return null;
  // Featured posts first (newest first); if fewer than two are featured, the newest posts fill the gaps.
  const shown = [...news.filter((n) => n.featured), ...news.filter((n) => !n.featured)]
    .slice(0, 2)
    .map((n, i) => ({ ...n, image: newsImages(n).home, delay: ['.3s', '.5s'][i] }));

  return (
    <div
      id="it-blog"
      className="it-blog-area it-blog-style-3 it-blog-style-4 pt-120 pb-90"
    >
      <div className="container">
        <div className="it-blog-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="it-blog-title-box">
                <span className="it-section-subtitle-5 purple-2">
                  <img src={titleImg} alt="" />
                  Campus News
                </span>
                <h4 className="ed-section-title">
                  Our Latest News <br /> From Campus Life
                </h4>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <div className="it-blog-button text-start text-md-end">
                <Link className="ed-btn-square" to="/news">
                  <span>View All News</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {shown.map((n) => (
            <div
              key={n.id}
              className="col-xl-6 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={n.delay}
            >
              <SingleBlogTwo
                to={`/news/${n.id}`}
                blogImage={n.image}
                title={n.titleShort}
                authorName={n.author}
                publishedDate={n.date}
                btnClass="ed-btn-square purple-3"
                btnText="Read More"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Blog;
